import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ConfigContext from '../contexts/ConfigContext';
import { Button } from 'reactstrap';
import { handleResponse } from '../utils/handlers';
import { Document, Page, pdfjs } from 'react-pdf';
import styles from './ConsignmentPod.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function ConsignmentPod(props) {

    const { consignmentId, podId } = useParams();
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pod, setPod] = useState(null);

    let history = useHistory();

    let config = useContext(ConfigContext);

    useEffect(() => {
        fetch(`api/pod/${podId}`, {
            credentials: 'include'
            })
            .then(handleResponse)
            .then(data => {
                setPod(data);
            })
            .catch(error => {
                console.log(error);
            });

    }, [podId]);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    return (
        <React.Fragment>
            {
                config && config.baseUrl && podId && pod && pod.contentType === 'application/pdf' &&
                <div>
                    <div className={styles.podContent}>
                        <Document file={`${config.baseUrl}/api/pod/${podId}/file`} onLoadSuccess={onDocumentLoadSuccess} >
                            <Page pageNumber={pageNumber} />
                        </Document>
                    </div>
                    {
                        numPages &&
                        <div className={styles.buttonNavigation}>
                            <Button outline color="primary" disabled={pageNumber <= 1}
                                onClick={previousPage}>Previous</Button>    
                            <div className={styles.pageInfo}>
                                {`Page ${pageNumber} of ${numPages}`}
                            </div>
                            <Button outline color="primary" disabled={pageNumber >= numPages}
                                onClick={nextPage}>Next</Button>
                        </div>
                    }
                </div>
            }
            {
                config && config.baseUrl && podId && pod && (pod.contentType === 'image/jpeg' || pod.contentType === 'image/png') &&
                <div className={styles.podContent}>
                    <img src={`${config.baseUrl}/api/pod/${podId}/file`} alt="" />
                </div>
            }
            <Button color="primary" onClick={e => history.push(`/consignment/${consignmentId}/pods`)} block>Back</Button>
        </React.Fragment>
        );
}

export { ConsignmentPod };